import React, { Component } from "react"
import onClickOutside from "react-onclickoutside"
import "./TableOfContents.css"

/**
 * Content entry in Rain Diaries table of contents. Clickable.
 *
 * @class      DiaryEntry (name)
 */
class ContentEntry extends Component {
  calculatedStyle() {
    const selectedStyle = { color: "#000000" }
    const notSelectedStyle = { color: "#d0d0d0" }

    let style = this.props.selected ? selectedStyle : notSelectedStyle
    style.display = this.props.visible ? "" : "none"

    return style
  }

  render() {
    return (
      <div
        className="ContentEntry"
        style={this.calculatedStyle()}
        onClick={this.props.onClick}
      >
        {this.props.entry.title}
      </div>
    )
  }
}

class TableOfContents extends Component {
  constructor(props) {
    super(props)
    this.state = { opened: false }
  }

  handleClickOutside(event) {
    this.setState({ opened: false })
  }

  /**
   * Renders a single table of contents entry from given input entry and index.
   *
   * @param      {<object>}  entry    Formatted entry
   * @param      {<number>}  index    Entry order index
   * @return     {<object>}  Rendered entry
   */
  renderEntry(entry, index) {
    return (
      <ContentEntry
        entry={entry}
        selected={index === this.props.current}
        visible={index === this.props.current || this.state.opened === true}
        onClick={() => {
          this.props.onEntryClick(index)
          this.setState({ opened: !this.state.opened })
        }}
      />
    )
  }

  render() {
    let shownItems = this.state.opened ? this.props.entries.length : 1
    let borderStyle = { "max-height": 1.5 * shownItems + "em" }

    // A hack to hide the cue symbol when the table is empty. Due to previous
    // hack an empty table is created by using a sigle entry with no contents.
    // Hide the cue symbol in that case.
    let cueSymbol = ""
    if (this.props.entries.length > 1) {
      cueSymbol = this.state.opened ? "▼" : "▶"
    }

    return (
      <div className="InteractionBlock TableOfContents" style={borderStyle}>
        <div className="TableOfContentsEntries">
          {this.props.entries.map((entry, index) =>
            this.renderEntry(entry, index),
          )}
        </div>
        <span
          className="Cue"
          onClick={() => {
            this.setState({ opened: !this.state.opened })
          }}
        >
          {cueSymbol}
        </span>
      </div>
    )
  }
}

export default onClickOutside(TableOfContents)



// WEBPACK FOOTER //
// ./src/components/TableOfContents.js